import React from 'react';

import { Box, Typography } from '@mui/material';
import ContentPanelMeta from './ContentPanelMeta';
import './EntryRow.css';

// CHANGED — regular function, hooks werken nu
const EntryRow = React.memo(({ entry, isSelected, onSelect }) => {
    return (
        <Box className="entry-row-wrapper" sx={{ bgcolor: '#0d1f33' }}>
            <Box
                id={`entry-row-${entry.rk}`}
                className={`entry-row-card ${isSelected ? 'entry-row-card--selected' : ''}`}
                onClick={() => onSelect(entry)}
            >
                <Typography
                    className={`entry-row-title ${isSelected ? 'entry-row-title--selected' : ''}`}
                    sx={entry.stateId === 1 ? { textDecoration: 'line-through', opacity: 0.5 } : {}}
                >
                    {entry.title}
                </Typography>

                {/* // ADDED — wrapper disables pointer events on meta chips */}
                <div style={{ pointerEvents: 'none' }}>
                    <ContentPanelMeta entry={entry} compact />
                </div>
            </Box>
        </Box>
    );
});

export default EntryRow;
